import useFeatures from 'hooks/useFeatures';
import useHostfullyAssist from 'pages/hostfullyAssist/useHostfullyAssist';
import useAppUser from '../../../../hooks/useAppUser';
import useHasRouteAccess from '../../../../router/useHasRouteAccess';
import { Item } from './Header.types';
import { itemsByRole } from './headerItemsConstants';

const useHeaderItems = () => {
  const hasRouteAccess = useHasRouteAccess();
  const allowedFlags = useFeatures();
  const hasItemAccess = (item: Item) => hasRouteAccess(item.path);
  const { userType } = useAppUser();
  const { isAssistEligible, assistMenuEntryPath } = useHostfullyAssist();

  const navigationProps = {
    ...itemsByRole({
      allowedFlags,
      dynamicItems: {
        assist: { isVisible: isAssistEligible, path: assistMenuEntryPath },
      },
    })[userType!],
  };
  navigationProps.navItems = navigationProps.navItems
    .filter(hasItemAccess)
    .filter(
      ({ allowedToRender }) =>
        !allowedToRender || allowedToRender(allowedFlags),
    );

  navigationProps.dropdownItems = navigationProps.dropdownItems
    .filter(hasItemAccess)
    .filter(
      ({ allowedToRender }) =>
        !allowedToRender || allowedToRender(allowedFlags),
    );
  navigationProps.dropdownSecondaryItems =
    navigationProps.dropdownSecondaryItems?.filter(hasItemAccess);
  return navigationProps;
};

export default useHeaderItems;
